import React, { Component } from "react";
import { Jumbotron } from "react-bootstrap";
import { I18n } from "react-i18nify";

class NotFound extends Component {
	render() {
		const divStyle = {
			marginLeft: "auto",
			marginRight: "auto",
			marginTop: 25,
			width: "15%"
		};

		const jumbStyle = {
			borderRadius: 4
		};
		const spanStyle = {
			textAlign: "center",
			display: "block"
		};

		return (
			<div style={divStyle}>
				<Jumbotron style={jumbStyle}>
					<span style={spanStyle}><b>{I18n.t("pageNotFound")}</b></span>
				</Jumbotron>
			</div>
		);
	}
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/views/NotFound.js